/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService
 */
import * as References from './BusinessUnitsService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#getBusinessUnits
 */
export const GET_BUSINESS_UNITS_QUERY_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_getBusinessUnits';
export const GET_BUSINESS_UNITS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetBusinessUnitsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BUSINESS_UNITS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetBusinessUnitsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getBusinessUnitsRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#getBusinessUnitsByUser
 */
export const GET_BUSINESS_UNITS_BY_USER_QUERY_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_getBusinessUnitsByUser';
export const GET_BUSINESS_UNITS_BY_USER_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetBusinessUnitsByUserResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BUSINESS_UNITS_BY_USER_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetBusinessUnitsByUserResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getBusinessUnitsByUserRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#getBusinessUnitById
 */
export const GET_BUSINESS_UNIT_BY_ID_QUERY_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_getBusinessUnitById';
export const GET_BUSINESS_UNIT_BY_ID_QUERY: RegisteredQuery<
  'result',
  References.GetBusinessUnitByIdRequestType,
  References.GetBusinessUnitByIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BUSINESS_UNIT_BY_ID_QUERY_FIELD_NAME,
  args: ['businessUnitId'],
  fetcher(
    request: References.GetBusinessUnitByIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetBusinessUnitByIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getBusinessUnitByIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#createBusinessUnit
 */
export const CREATE_BUSINESS_UNIT_MUTATION_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_createBusinessUnit';
export const CREATE_BUSINESS_UNIT_MUTATION: RegisteredQuery<
  'result',
  References.CreateBusinessUnitRequestType,
  References.CreateBusinessUnitResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_BUSINESS_UNIT_MUTATION_FIELD_NAME,
  args: ['name', 'allUsersHaveAccess'],
  fetcher(
    request: References.CreateBusinessUnitRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateBusinessUnitResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createBusinessUnitRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#updateBusinessUnit
 */
export const UPDATE_BUSINESS_UNIT_MUTATION_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_updateBusinessUnit';
export const UPDATE_BUSINESS_UNIT_MUTATION: RegisteredQuery<
  'result',
  References.UpdateBusinessUnitRequestType,
  References.UpdateBusinessUnitResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_BUSINESS_UNIT_MUTATION_FIELD_NAME,
  args: ['businessUnitId', 'name', 'allUsersHaveAccess'],
  fetcher(
    request: References.UpdateBusinessUnitRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateBusinessUnitResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateBusinessUnitRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#deleteBusinessUnit
 */
export const DELETE_BUSINESS_UNIT_MUTATION_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_deleteBusinessUnit';
export const DELETE_BUSINESS_UNIT_MUTATION: RegisteredQuery<
  'result',
  References.DeleteBusinessUnitRequestType,
  References.DeleteBusinessUnitResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_BUSINESS_UNIT_MUTATION_FIELD_NAME,
  args: ['businessUnitId'],
  fetcher(
    request: References.DeleteBusinessUnitRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteBusinessUnitResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.deleteBusinessUnitRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#getUserDefaultBusinessUnit
 */
export const GET_USER_DEFAULT_BUSINESS_UNIT_QUERY_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_getUserDefaultBusinessUnit';
export const GET_USER_DEFAULT_BUSINESS_UNIT_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetUserDefaultBusinessUnitResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_USER_DEFAULT_BUSINESS_UNIT_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetUserDefaultBusinessUnitResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getUserDefaultBusinessUnitRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#setUserDefaultBusinessUnit
 */
export const SET_USER_DEFAULT_BUSINESS_UNIT_MUTATION_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_setUserDefaultBusinessUnit';
export const SET_USER_DEFAULT_BUSINESS_UNIT_MUTATION: RegisteredQuery<
  'result',
  References.SetUserDefaultBusinessUnitRequestType,
  References.SetUserDefaultBusinessUnitResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_USER_DEFAULT_BUSINESS_UNIT_MUTATION_FIELD_NAME,
  args: ['businessUnitId', 'allBrandsDefault'],
  fetcher(
    request: References.SetUserDefaultBusinessUnitRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetUserDefaultBusinessUnitResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.setUserDefaultBusinessUnitRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#clearUserDefaultBusinessUnit
 */
export const CLEAR_USER_DEFAULT_BUSINESS_UNIT_MUTATION_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_clearUserDefaultBusinessUnit';
export const CLEAR_USER_DEFAULT_BUSINESS_UNIT_MUTATION: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.ClearUserDefaultBusinessUnitResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CLEAR_USER_DEFAULT_BUSINESS_UNIT_MUTATION_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ClearUserDefaultBusinessUnitResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.clearUserDefaultBusinessUnitRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#getPrimaryBrandId
 */
export const GET_PRIMARY_BRAND_ID_QUERY_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_getPrimaryBrandId';
export const GET_PRIMARY_BRAND_ID_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetPrimaryBrandIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PRIMARY_BRAND_ID_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPrimaryBrandIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPrimaryBrandIdRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService#setPrimaryBrandId
 */
export const SET_PRIMARY_BRAND_ID_MUTATION_FIELD_NAME =
  'com_hubspot_business_units_rpc_BusinessUnitsService_setPrimaryBrandId';
export const SET_PRIMARY_BRAND_ID_MUTATION: RegisteredQuery<
  'result',
  References.SetPrimaryBrandIdRequestType,
  References.SetPrimaryBrandIdResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_PRIMARY_BRAND_ID_MUTATION_FIELD_NAME,
  args: ['brandId'],
  fetcher(
    request: References.SetPrimaryBrandIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetPrimaryBrandIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.setPrimaryBrandIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
